import { Modal, Paper, Typography, Button } from "@mui/material";
import { useDeleteNote } from "../../../../hooks/panelClient/useDeleteNote";
import { useDeleteWitness } from "../../../../hooks/panelClient/useDeleteWitness";

export const ModalDeleteWitness = ({
  token,
  open,
  close,
  note,
  testigo,
  onWitnessDeleted,
}) => {
  const { deleteNote } = useDeleteNote(token, note, onWitnessDeleted, close);
  const { deleteWitness } = useDeleteWitness(token);

  const handleConfirm = async () => {
    const result = await deleteWitness(testigo.witness_id);
    if (result === true) {
      onWitnessDeleted(testigo.witness_id);
      if (note?.testigo?.length === 1) {
        await deleteNote();
      }
    }
    close();
  };

  return (
    <Modal open={open} onClose={close}>
      <Paper
        elevation={2}
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          padding: "20px",
          display: "flex",
          flexDirection: "column",
          outline: "none",
        }}
      >
        <Typography variant="h6" sx={{ mb: 2 }}>
          ¿Estás seguro de que deseas eliminar este testigo?
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Esta acción no se podrá deshacer. <br />
          {note?.testigo?.length === 1 && (
            <strong> También se eliminará la nota de forma permanente.</strong>
          )}
        </Typography>
        <div style={{ display: "flex", justifyContent: "end" }}>
          <Button variant="contained" onClick={close} color="error">
            Cancelar
          </Button>
          <Button
            variant="contained"
            color="primary"
            style={{ marginLeft: "20px" }}
            onClick={handleConfirm}
          >
            Confirmar
          </Button>
        </div>
      </Paper>
    </Modal>
  );
};
